import Wix from './wix-sdk-polyfill';
import { clearMembers, fetchMembers } from '../state/members-page/actions';

export default function listenToMemberChange(store) {
  Wix.addEventListener(Wix.Events.MEMBER_DETAILS_UPDATED, () => {
    store.dispatch(clearMembers());
    store.dispatch(fetchMembers());
  });
}
